export default __webpack_public_path__ + "499bb7222f1a720730136e421b58a5ec.svg";